<script>
import { mapActions } from 'vuex'


export default {
  name: 'NumberCard',
  props: {
    card: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      requesting: true,
      total: 0,
    }
  },
  async created() {
    this.requesting = true
    const res = await this.getClicksNew({ dataType: this.card.type })

    this.total = res
    this.requesting = false
  },
  methods: {
    ...mapActions('dashboard', ['getClicksNew']),
  },
}
</script>

<template>
  <data-box
    :status="false"
    :class="$style.card"
  >
    <div :class="$style.body">
      <base-loader v-if="requesting" />
      <template v-else>
        <div>
          <div :class="$style.number">
            {{ total }}
          </div>
          <span>
            {{ card.text }}
          </span>
        </div>
        <div :class="$style.imageWrapper">
          <img
            :src="card.img"
            :alt="card.text"
          >
        </div>
      </template>
    </div>
  </data-box>
</template>

<style lang="scss" module>
  .card {
    :global {
      .el-card__body {
        padding: rem(28px 40px 28px 35px);
      }
    }
  }

  .body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: rem(14px);
  }

  .number {
    margin-bottom: rem(10px);
    font-size: rem(28px);
    line-height: rem(28px);
  }

  .imageWrapper {
    margin-left: rem(10px);

    img {
      width: 100%;
      max-width: rem(40px);
      max-height: rem(40px);
      object-fit: cover;
    }
  }
</style>
